<div class="clientNavigation w-100" [ngClass]="menuHidden ? 'hide' : 'expandMenu'">
  <div class="logoContainer">
    <img *ngIf="showBrandedLogo" [src]="logoSrc" (click)="onLogoClick()" alt="" class="img-fluid" />
  </div>
  <div class="bottomNav curveCorner curveRight text-end">
    <app-bottom-nav-actions
      [activeMode]="type"
      [rongoUrl]="rongoUrl"
      (navigate)="onBottomNavNavigate($event)"
    ></app-bottom-nav-actions>

    <span class="nav-divider" *ngIf="isAuthenticated"></span>

    <app-user-menu
      *ngIf="isAuthenticated"
      class="nav-item"
      [userName]="currentUserName"
      [isAdmin]="!!currentUser?.isAdmin"
      [signOutLabel]="'Sign out' | translate"
      [adminLabel]="'Admin' | translate"
      [profileLabel]="'Profile settings' | translate"
      [termsLabel]="'Terms of use' | translate"
      (signOut)="logout()"
      (openAdmin)="openAdmin()"
    ></app-user-menu>
  </div>
  <!-- Navigation Links Container -->
  <div
    class="mainNavigation container py-5"
    [ngClass]="menuAnimate ? 'NoAnim' : 'animate__animated animate__fadeIn animate__delay-1s'"
  >
    <div class="row w-100 mt-3">
      <div class="col-md-3" *ngFor="let meniItem of menuJSON">
        <h2>{{ meniItem?.name }}</h2>
        <div *ngIf="meniItem?.name !== 'Information'">
          <ul>
            <li *ngFor="let childItem of meniItem.children">
              <a href="javascript:;" (click)="childItem.url !== '#' && menuClick(childItem.url)">{{
                childItem.name
              }}</a>
            </li>
            <div *ngFor="let childItem of meniItem.children">
              <li *ngIf="childItem?.children === undefined">
                <a href="javascript:;" (click)="toggleMenu(); childItem.url !== '#' && menuClick(childItem.url)">{{
                  childItem.name
                }}</a>
              </li>
              <li *ngIf="childItem?.children">
                <mat-accordion>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      {{ childItem?.name }}
                    </mat-expansion-panel-header>
                    <ul>
                      <li *ngFor="let item of childItem.children">
                        <a href="javascript:;" (click)="toggleMenu(); item.url !== '#' && menuClick(item.url)">{{
                          item.name
                        }}</a>
                        <!-- {{item.name}} -->
                      </li>
                    </ul>
                  </mat-expansion-panel>
                </mat-accordion>
              </li>
            </div>
          </ul>
        </div>
        <div *ngIf="meniItem?.name === 'Information'">
          <ul>
            <li *ngFor="let childItem of meniItem.children">
              {{ childItem.name }}
              <div class="menu-info">
                <ul *ngIf="childItem?.children">
                  <li *ngFor="let innerItem of childItem.children">
                    <a href="javascript:;" (click)="toggleMenu(); innerItem.url !== '#' && menuClick(innerItem.url)">{{
                      innerItem.name
                    }}</a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <!-- Navigation Links Container -->
</div>

<div class="clientContent client-wm">
  <router-outlet></router-outlet>
</div>
